module.exports = __webpack_public_path__ + "static/media/img-how-qr-code-works.6dda8f51.svg";